import React from 'react';

import sort from '../../utils/sort/index.ts';
import useStorage from '../../utils/useStorage/index.ts';

export type Update = {
  /**
   * Timestamp of this update
   */
  timestamp: string;
  /**
   * The URL to the update page (webflow)
   * */
  url: string | null;
  /**
   * The title of the update
   * */
  title: React.ReactNode;
  /**
   * Short description of the updates made
   * */
  description: React.ReactNode;
};

function useUpdatesIndicator(updates: Update[]): {
  shouldShowUpdates: boolean;
  sawLatestUpdate: () => void;
  hasUpdates: boolean;
  numUpdates: number;
  latestUpdate: Update | null;
} {
  const [lastSeenUpdate, setSeenUpdate] = useStorage('updates-indicator', '' as string);
  const latestUpdate = sort(updates, 'timestamp', { ascending: false })[0] ?? null;
  const numUpdates = updates.length;
  const hasUpdates = Boolean(numUpdates);
  const shouldShowUpdates = hasUpdates && lastSeenUpdate !== latestUpdate?.timestamp;

  return {
    shouldShowUpdates,
    latestUpdate,
    sawLatestUpdate: () => setSeenUpdate(latestUpdate?.timestamp),
    hasUpdates,
    numUpdates
  };
}
export default useUpdatesIndicator;
